import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGooglecolabComponent } from './simple-icons-googlecolab.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGooglecolabComponent ],
    exports:      [ SimpleIconsGooglecolabComponent ],
    bootstrap:    []
})
export class SimpleIconsGooglecolabModule {}
